import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useWizard } from "react-use-wizard";
import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import OrangeCalendar from "../../img/icons/icon_calendar_orange.png";
import Moment from "moment";
import { useTranslation } from "react-i18next";
import createPersistedState from "use-persisted-state";
const useClinicState = createPersistedState("clinic");

const FinalConfirmWaitingListStep = ({ currentDate, selectedClinic }) => {
  const { previousStep } = useWizard();
  const [isFetchingData, setIsFetchingData] = useState(false);
  let history = useHistory();
  const { t, i18n } = useTranslation();
  const [clinicId, setClinic] = useClinicState();

  // fetch post for booking
  const confirmWaitingList = async () => {
    setIsFetchingData(true);
    const token = "Bearer " + localStorage.getItem("token");
    const attendeeId = JSON.parse(localStorage.getItem("pid"));
    const POST_URL = `/api/v1/waiting/${clinicId}`;
    try {
      const data = {
        date: currentDate.date,
        attendeeId: attendeeId,
        ownerId: "DR000001",
        location: selectedClinic === "CC000001" ? "Bhandup" : "Kalyan",
        note: "missed appointment",
      };
      const response = await fetch(`${POST_URL}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=utf-8",
          Authorization: token.replace(/['"]+/g, ""),
        },
        body: JSON.stringify(data),
        credentials: "include",
      });
      const res = await response.json();
      // console.log(res);
      if (response.status !== 200) {
        const error = new Error(response.error);
        throw error;
      } else {
        history.push("/my-appointments");
      }
    } catch (err) {
      console.log(err);
    }
    setIsFetchingData(false);
  };

  const selectedDateDisplay = Moment(new Date(currentDate?.date)).format(
    "DD MMMM YYYY"
  );
  console.log(selectedDateDisplay);
  return (
    <>
      <NavigateBackWizardStep
        clickHandler={() => previousStep()}
        title={t("appointment.WAITLIST.topHeading")}
      />
      <div className="body_content py-3">
        <div className="inner_body  text-center">
          <div>
            <span className="icon">
              <img
                src={OrangeCalendar}
                alt=""
                className="img-fluid d-block mx-auto w-25 mt-3"
              />
            </span>
          </div>
          <div className="modal-body">
            <div className="content_modal text-center">
              <h6 className="txt_small my-5  ">
                {/* {t('appointment.WAITLIST.message3')} <br /> {selectedDateDisplay} {t('appointment.WAITLIST.topHeading')}. <br />
              {t('appointment.WAITLIST.open')} */}
                {i18n.language !== "hi" && i18n.language !== "mr" && (
                  <>
                    <>{t("appointment.WAITLIST.message3")}</>
                    <br />
                    <>
                      {" "}
                      {selectedDateDisplay}{" "}
                      {t("appointment.WAITLIST.topHeading")}.
                    </>
                    <br />
                    <>{t("appointment.WAITLIST.open")}</>
                  </>
                )}
                {(i18n.language === "hi" || i18n.language === "mr") && (
                  <>
                    <>
                      {selectedDateDisplay}{" "}
                      {t("appointment.WAITLIST.topHeading")}
                    </>
                    <br />
                    <>{t("appointment.WAITLIST.message3")}</>
                    <br />
                    <>{t("appointment.WAITLIST.open")}</>
                  </>
                )}
              </h6>
            </div>
          </div>
          <div className="btn_block bottom_button d-flex align-items-center justify-content-center">
            <button
              id="btn_bookapp"
              className="w-50  btn btn_primary "
              disabled={isFetchingData}
              onClick={() => confirmWaitingList()}
            >
              {isFetchingData && (
                <span className="icon ml-4 fa-solid fa-spinner fa-spin"></span>
              )}
              &nbsp;{t("appointment.BUTTON.ok")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FinalConfirmWaitingListStep;
